import { IUsuario } from "../interfaces/IUsuario";
import { REVISADOS_PREFIX } from "../pages/andamentoContas/conciliacaoRevisados";

export default class StorageUtils {
    // async function getItem(item){
    //     return localStorage.getItem(item)
    // }

    // async function setItem(item){
    //     return localStorage.getItem(item)
    // }

    // Chaves que sobrevivem ao logout/401. Já são isoladas por usuário na própria chave.
    static readonly PREFIXOS_PRESERVADOS = [REVISADOS_PREFIX];

    static async clearStorage(){
        const chaves: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const chave = localStorage.key(i);
            if (chave !== null) chaves.push(chave);
        }

        chaves
            .filter(chave => !StorageUtils.PREFIXOS_PRESERVADOS.some(prefixo => chave.startsWith(prefixo)))
            .forEach(chave => localStorage.removeItem(chave));
    }

    static async getUsuario(): Promise<IUsuario | undefined> {
        const userJson = localStorage.getItem("usuario");

        if (userJson === null) {
            return;
        }

        const user = JSON.parse(userJson);

        return user;
    }

    static setUsuario(usuario: IUsuario): void {
        localStorage.setItem("usuario", JSON.stringify(usuario));
    }

    static async getToken(): Promise<string | null> {
        const token = localStorage.getItem("token");

        if (token === null) {
            return null;
        }

        return token;
    }

    static setToken(token: string): void {
        localStorage.setItem("token", token);
    }

    // Hora do login (epoch ms), base do limite de 48h da sessão (DEVN3-760).
    static getSessaoInicio(): number | null {
        const valor = Number(localStorage.getItem("sessaoInicio"));
        return Number.isFinite(valor) && valor > 0 ? valor : null;
    }

    static setSessaoInicio(inicio: number): void {
        localStorage.setItem("sessaoInicio", String(inicio));
    }
}